import classnames from 'classnames';

export interface IStackedFormGroupProps {
    children: React.ReactNode;
    className?: string;
    colSizeAuto?: boolean;
    hasErrors?: boolean;
}

// Default behaviour: when multiple columns are used in a FormRow, they will take up the space evenly.
// Use colSizeAuto to size columns based on the natural width of their content.

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function StackedFormGroup(props: IStackedFormGroupProps) {
    return (
        <div
            className={classnames(
                'form-group col stacked-formgroup',
                props.hasErrors ? ' has-danger' : '',
                props.colSizeAuto ? 'col-auto' : '',
                props.className || ''
            )}
        >
            {props.children}
        </div>
    );
}
